<template>
    <be-loading :active="null === sectorOptions">
        <form class="form-horizontal group-border-dashed" @submit.prevent="handleSubmit" novalidate>
            <div class="container p-0">
                <div class="form-group">
                    <h3 class="wizard-title text-uppercase">Kundeninformation – Eigenschaften</h3>
                </div>

                <select-menu label="Branche" horizontal :options="sectorOptions" :disabled="disabled" v-model="formData.sector" :validation="$v.formData.sector" v-if="hasSectors"/>
                <text-field label="Anzahl Mitarbeiter (Vollzeitstellen)" horizontal :disabled="disabled" v-model="formData.employees" :validation="$v.formData.employees"/>

                <range-slider
                    class="pb-8"
                    label="Jahresumsatz"
                    horizontal
                    :formatter="formatTurnover"
                    :connect="true"
                    :min="10000"
                    :max="10000000"
                    :range="{
                        min: [10000, 5000],
                        '30%': [100000, 10000],
                        '50%': [250000, 25000],
                        '60%': [500000, 50000],
                        '80%': [1000000, 100000],
                        '90%': [5000000, 250000],
                        max: [10000000],
                    }"
                    :pips="{
                        mode: 'values',
                        values: [10000, 50000, 100000, 500000, 1000000, 5000000, 10000000],
                        density: 4,
                        stepped: true,
                        format: {
                            to: (v) => (v >= 1000000 && `${v/1000000}m` || `${v/1000}k`),
                            from: v => v,
                        },
                    }"
                    v-model="formData.turnover"
                />

                <be-form-group horizontal v-if="!disabled">
                    <button class="btn btn-lg btn-secondary btn-space" type="button" @click.prevent="$emit('previous', formData)">zurück</button>
                    <button class="btn btn-lg btn-primary btn-space wizard-next" type="submit">weiter</button>
                </be-form-group>
            </div>
        </form>
    </be-loading>
</template>

<script>
    import { required, numeric } from 'vuelidate/lib/validators';

    import exam from '../../../mixins/exam';
    import Sectors from '../../../data/Sectors';

    export default {
        mixins: [exam],

        data: () => ({
            formData: {
                sector: null,
                employees: '',
                turnover: [10000, 10000000],
            },
        }),

        validations() {
            const validations = {
                formData: {
                    employees: {
                        required,
                        numeric,
                    },
                },
            };

            if (this.hasSectors) {
                validations.formData.sector = { required };
            }

            return validations;
        },

        asyncComputed: {
            sectorOptions: vm => Sectors.getOptions(vm.disabled ? '–' : 'Bitte wählen …'),
            hasSectors: () => Sectors.hasSectors(),
        },

        methods: {
            formatTurnover(values) {
                let from = values[0];
                let to = values[1];

                if (Intl && Intl.NumberFormat) {
                    from = new Intl.NumberFormat('de-CH').format(from);
                    to = new Intl.NumberFormat('de-CH').format(to);
                }

                return `${from} bis ${to} CHF`;
            },
        },
    };
</script>
